<div class="save-dialog">
  <div class="save-dialog__header">
    <mat-icon class="save-dialog__icon">save</mat-icon>
    <h2 class="save-dialog__title">{{ 'Save Template' | translate }}</h2>
  </div>
  <hr class="save-dialog__divider">

  <div class="save-dialog__body">
    <button
      class="save-dialog__option"
      [class.save-dialog__option--active]="saveAction === SaveAction.Override"
      [class.save-dialog__option--disabled]="!data.canManage"
      [disabled]="!data.canManage"
      (click)="selectSave(SaveAction.Override)">
      <mat-icon class="save-dialog__option-icon">{{ !data.canManage ? 'lock' : 'save' }}</mat-icon>
      <span class="save-dialog__option-label">{{ 'Override template' | translate }}</span>
    </button>
    @if (!data.canManage && data.isDefault) {
      <p class="save-dialog__hint">
        {{ 'Default template — save as a copy instead' | translate }}
      </p>
    }
    @if (!data.canManage && !data.isDefault) {
      <p class="save-dialog__hint">
        {{ 'Shared template — save as a copy instead' | translate }}
      </p>
    }

    <button
      class="save-dialog__option"
      [class.save-dialog__option--active]="saveAction === SaveAction.SaveAsNew"
      (click)="selectSave(SaveAction.SaveAsNew)">
      <mat-icon class="save-dialog__option-icon">add_circle_outline</mat-icon>
      <span class="save-dialog__option-label">{{ 'Save as new' | translate }}</span>
    </button>

    @if (saveAction === SaveAction.SaveAsNew) {
      <div class="save-dialog__new-form">
        <label class="save-dialog__label">{{ 'Name' | translate }}</label>
        <mat-form-field appearance="outline" class="save-dialog__name-field">
          <input matInput [(ngModel)]="newName" [placeholder]="'Name' | translate" />
          @if (isNameDuplicate) {
            <mat-error>{{ 'Name already exists' | translate }}</mat-error>
          }
        </mat-form-field>
        <div class="save-dialog__share-row">
          <mat-slide-toggle [(ngModel)]="share" color="primary">
            {{ 'Share with others' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    }
  </div>

  <hr class="save-dialog__divider">
  <div class="save-dialog__actions">
    <button class="btn save-dialog__btn save-dialog__btn--cancel" (click)="cancel()">
      <mat-icon>close</mat-icon>
      {{ 'Cancel' | translate }}
    </button>
    <button
      class="btn save-dialog__btn save-dialog__btn--confirm"
      [disabled]="!isConfirmEnabled"
      (click)="confirm()">
      <mat-icon>check</mat-icon>
      {{ 'Confirm' | translate }}
    </button>
  </div>
</div>
